import type { SVGProps } from 'react';
import { siZapier } from 'simple-icons';
import { INTEGRATION_BRANDS } from '@/lib/brand/integration-brands';

export const ZapierBrand = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill={INTEGRATION_BRANDS.zapier.primary}>
    <path d={siZapier.path} />
  </svg>
);
